/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IAboutSectionProps {
    aboutWhoWeAreLabel?: string;
    aboutHeading?: string;
    aboutDescription?: string;
    aboutReadMoreLabel?: string;
    aboutReadMoreLink?: string;
    aboutImage?: string;
    aboutSectionId?: string;
}

export const AboutSection = ({
    aboutSectionId,
    aboutWhoWeAreLabel,
    aboutHeading,
    aboutDescription,
    aboutReadMoreLabel,
    aboutReadMoreLink,
    aboutImage
}: IAboutSectionProps) => {
    const _renderAboutHeading = () => {
        if (aboutHeading) {
            return <h2>{aboutHeading}</h2>;
        }
    };

    const _renderAboutDescription = () => {
        if (aboutDescription) {
            return <p>{aboutDescription}</p>;
        }
    };

    const _renderReadMore = () => {
        if (aboutReadMoreLabel) {
            return (
                <div className="text-center text-lg-start">
                    <a
                        href={aboutReadMoreLink}
                        className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center"
                    >
                        <span>{aboutReadMoreLabel}</span>
                        <i className="bi bi-arrow-right" />
                    </a>
                </div>
            );
        }
    };

    const _renderImage = () => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "zoom-out",
                "data-aos-delay": "200"
            };
        }
        if (aboutImage) {
            return (
                <div
                    className={`col-lg-6 d-flex align-items-center`}
                    {...{ ..._aos_props }}
                >
                    <img src={aboutImage} className="img-fluid" alt="" />
                </div>
            );
        }
    };
    const _getTitleClassName = () => {
        if (aboutImage) {
            return "col-lg-6";
        }
        return "col-lg-12";
    };
    let _aos_container_props: any = {};
    if (!isIOS) {
        _aos_container_props = {
            "data-aos": "fade-up"
        };
    }
    let _aos_title_props: any = {};
    if (!isIOS) {
        _aos_title_props = {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
        };
    }
    return (
        <section id={aboutSectionId} className="about">
            <div className="container" {..._aos_container_props}>
                <div className="row gx-0">
                    <div
                        className={`${_getTitleClassName()} d-flex flex-column justify-content-center`}
                        {..._aos_title_props}
                    >
                        <div
                            style={{
                                backgroundColor: "#f6f9ff",
                                padding: "40px"
                            }}
                        >
                            <h3>{aboutWhoWeAreLabel}</h3>
                            {_renderAboutHeading()}
                            {_renderAboutDescription()}
                            {_renderReadMore()}
                        </div>
                    </div>
                    {_renderImage()}
                </div>
            </div>
        </section>
    );
};

AboutSection.defaultProps = {
    aboutWhoWeAreLabel: "WHO WE ARE",
    aboutReadMoreLink: "#",
    aboutSectionId: "about"
};
